type CountryFormat = {
  code: string;
  mask: string;
  length: number;
};

export const formats = {
  Mexico: { code: "52", mask: "+52 (xxx) xxx-xxxx", length: 11 } as CountryFormat,
  US: { code: "1", mask: "+1 (xxx) xxx-xxxx", length: 11 } as CountryFormat,
};

export function formatPhoneNumber(phoneNumber: string): string {
  const format = getPhoneFormat();
  let formatted = getPhoneDigits(phoneNumber).substring(format.code.length);

  if (formatted.length === 0) return "+1";

  for (let maskIndex = 0; maskIndex < format.mask.length; maskIndex++) {
    const maskChar = format.mask[maskIndex];
    if (maskChar !== "x" && maskIndex < formatted.length) {
      formatted = `${formatted.substring(0, maskIndex)}${maskChar}${formatted.substring(maskIndex)}`;
    }
  }

  return formatted;
}

export function getPhoneDigits(phoneNumber: string, trimRight = false): string {
  const format = getPhoneFormat();

  const digits = phoneNumber.replace(/\D/g, "");

  if (digits.length <= format.length) {
    return digits;
  }
  return trimRight ? digits.slice(digits.length - format.length, digits.length) : digits.slice(0, format.length);
}

export function getPhoneFormat(phoneNumber?: string): CountryFormat {
  if (phoneNumber) {
    const onlyDigits = phoneNumber.replace(/\D/g, "");
    const country = Object.values(formats).find((f) => onlyDigits.startsWith(f.code));
    return country ?? formats.US;
  }
  return formats.US;
}
